import React from 'react'
import Footer from '../component/Footer'

import Diabetic from '../Media/img/Diabetic foot.png'

const DiabeticFootMedia = () => {
  return (
    <>
      <div className="headings">
        <h1>Diabetic Foot Media</h1>
      </div>

      <div style={{ width: '100%' }}>
        <img src={Diabetic} style={{ width: '100%' }} />
      </div>

      <Footer />
    </>
  )
}

export default DiabeticFootMedia
